import { areDatesNotEqual, areNotEqual, isDateEmpty, isDropdownEmpty, isNumberEmpty } from "@/common/validation-checkers";
import ITripPayment from "@/models/trip-payments/itrip-payment";

export function TripPaymentHasRequiredFormFields(tripPayment: ITripPayment) {
    if (!tripPayment) {
        return false;
    }

    if (
        !isDateEmpty(tripPayment.paymentDate) &&
        !isNumberEmpty(tripPayment.amount) &&
        !isDropdownEmpty(tripPayment.methodId)
    ) {
        return true;
    } else {
        return false;
    }
}

export function TripPaymentHasChanged(original: ITripPayment, revised: ITripPayment) {
    if (!original || !revised) {
        return false;
    }

    if (
        areDatesNotEqual(original.paymentDate, revised.paymentDate) ||
        areNotEqual(original.amount, revised.amount) ||
        areNotEqual(original.methodId, revised.methodId)
    ) {
        return true;
    } else {
        return false;
    }
}